// extracted by mini-css-extract-plugin
module.exports = {"stickyNoteTooltip":"StickyNoteTooltip_stickyNoteTooltip__2OShF"};